

export const JsonLineBreak = ({ element }) => {

  return (
    <div className="w-full">
      {element.showLine ? <hr className="my-4" /> : <div className=""> </div>}
    </div>
  )
}